module.exports = __webpack_public_path__ + "static/img/twjd-sde1.c1f1fa1.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/details/twjd-sde1.png
// module id = 230
// module chunks = 0